<footer [class.ml-230]="showSideBar" id="footer-col-1" [style.width]="!showSideBar ? '100%' : 'calc(100% - 230px)'" class="px-3">
    &copy; WHO All rights reserved. <span class=" ms-auto">NoK (Nugget of Knowledge)</span>
</footer>